import React, { useState } from "react";
import { emailValidation, notEmptyValidation, urlValidation } from "../../../functions/validations";

const InputArea = (props) => {
  const {
    label,
    placeholder,
    rows,
    value,
    onChange,
    name,
    validation,
    notRequired,
    errorText,
    size = "md",
    className,
    helperText,
    style,
  } = props;

  const [error, seterror] = useState(null);

  function checkValidation() {
    if (validation === "ne") {
      if (notRequired) {
        value && !notEmptyValidation(value) && seterror(errorText ? errorText : "Required Input");
      } else {
        !notEmptyValidation(value) && seterror(errorText ? errorText : "Required Input");
      }
    } else if (validation === "email") {
      if (notRequired) {
        value && !emailValidation(value) && seterror(errorText ? errorText : "Invalid E-mail Address");
      } else {
        !emailValidation(value) && seterror(errorText ? errorText : "Invalid E-mail Address");
      }
    } else if (validation === "url") {
      if (notRequired) {
        value && !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
      } else {
        !urlValidation(value) && seterror(errorText ? errorText : "Invalid URL");
      }
    } else {
      seterror(null);
    }
  }
  return (
    <div className={`input-area ${size} ${error ? "input-error" : ""} ${className}`} style={style}>
      <p className="label">{label}</p>
      <div className="input">
        <textarea
          type="text"
          placeholder={placeholder}
          rows={rows}
          value={value}
          onChange={(e) => {
            error && seterror(null);
            onChange(e);
          }}
          name={name}
          onBlur={checkValidation}
        />
      </div>
      {helperText && <p className="helper-text">{helperText}</p>}
    </div>
  );
};

export default InputArea;
